import React from "react";
import { SubscribedUserPaymentWrapper } from "./SubscribedUserPaymentWrapper";
import { UnSubscribedUserPaymentWrapper } from "./UnSubscribedUserPaymentWrapper";
import { UnSubscribedUserSubscriptionPaymentWrapper } from "./UnSubscribedUserSubscriptionPaymentWrapper";

export const SelectPaymentPage = ({
	notSubscribed,
	paymentDetails,
	getHostPage,
	cancelSubscription,
	handleCancel,
	handleOk,
	cancelConfirmationModal,
	cancelConfirmation,
	getAddonDetails,
	invoicesData,
	getInvoicesList,
	ownerUpdatedMessage,
	openPaymentModal,
	invalidEmail,
	changeOwner,
	cancelSubscriptionResponseMessage,
	isSubscriptionCancelled,
	ownerUpdateResponseMessage,
	changePayerDetailsModal,
	changeEmailModal,
	updatePayerEmail,
	payerEmail,
	openPaymentPortal,
	reActiveConfirmation,
}) => {
	let subscriptionId = localStorage.getItem("subscriptionId");
	if (notSubscribed && (subscriptionId != "null" && subscriptionId != null)) {
		return (
			<UnSubscribedUserSubscriptionPaymentWrapper
				openPaymentPortal={openPaymentPortal}
                reActiveConfirmation={reActiveConfirmation}
                changePayerDetailsModal={changePayerDetailsModal}
                getHostPage={getHostPage}
                openPaymentModal={openPaymentModal}
                handleCancel={handleCancel}
                handleOk={handleOk}
			/>
		);
	} else if (notSubscribed) {
		return (
			<UnSubscribedUserPaymentWrapper openPaymentPortal={openPaymentPortal} />
		);
	} else {
		return (
			<SubscribedUserPaymentWrapper
				paymentDetails={paymentDetails}
				getHostPage={getHostPage}
				cancelSubscription={cancelSubscription}
				handleCancel={handleCancel}
				handleOk={handleOk}
				isSubscriptionCancelled={isSubscriptionCancelled}
				cancelSubscriptionResponseMessage={cancelSubscriptionResponseMessage}
				cancelConfirmationModal={cancelConfirmationModal}
				cancelConfirmation={cancelConfirmation}
				getAddonDetails={getAddonDetails}
				invoicesData={invoicesData}
				getInvoicesList={getInvoicesList}
				ownerUpdateResponseMessage={ownerUpdateResponseMessage}
				ownerUpdatedMessage={ownerUpdatedMessage}
				openPaymentModal={openPaymentModal}
				invalidEmail={invalidEmail}
				changeOwner={changeOwner}
				changePayerDetailsModal={changePayerDetailsModal}
				changeEmailModal={changeEmailModal}
				updatePayerEmail={updatePayerEmail}
				payerEmail={payerEmail}
				reActiveConfirmation={reActiveConfirmation}
			/>
		);
	}
};
